// src/mixins/quillImageUploadMixin.js
export default {
  methods: {
    /**
     * Checks if a file's size is within the given limit (in MB).
     * @param {File} file - The file to check.
     * @param {number} limitMB - Maximum allowed file size in MB (default 2 MB).
     * @returns {boolean} - True if file size is acceptable; false otherwise.
     */
    checkFileSize(file, limitMB = 2) {
      const limitBytes = limitMB * 1024 * 1024;
      if (file.size > limitBytes) {
        alert(`File size should not exceed ${limitMB} MB.`);
        return false;
      }
      return true;
    },
  },
};